<ion-item with-border lines="none" class="ion-padding" class="ion-hide-md-down">
  <ion-avatar slot="start">
    <img [src]="user?.userPhotoUrl ? user?.userPhotoUrl : 'assets/svg/avatar-white.svg'" />
  </ion-avatar>

  <ion-label>
    <h1 class="text-primary" bold>{{ user?.userName }}</h1>
    <h4 class="text-primary" regular>{{ user?.userDocument | mask: 'doc' }}</h4>
  </ion-label>

  <ion-label>
    <h3 class="text-primary-dark" padding-bottom-half>
      <ion-icon color="primary" src="assets/svg/mail.svg" padding-right-half></ion-icon>
      {{ user?.userEmail }}
    </h3>
    <h3 class="text-primary-dark">
      <ion-icon color="primary" src="assets/svg/phone.svg" padding-right-half></ion-icon>

      {{ user?.userPhone | mask: 'tel' }}
    </h3>
  </ion-label>

  <ion-button fill="outline" (click)="editButtonEvent.emit()">{{'COMPONENTS.EDIT_PROFILE' | translate}}</ion-button>
</ion-item>

<ion-item lines="none" class="ion-hide-md-up background-primiary">
  <ion-avatar class="size-55" slot="start">
    <img src="assets/svg/avatar-white.svg" />
  </ion-avatar>

  <ion-label>
    <h5 class="text-white" bold>{{ user?.userName }}</h5>
    <h6 class="text-white" regular>{{ user?.userDocument | mask: 'doc' }}</h6>
  </ion-label>

  <ion-button
    color="white-primary"
    fill="solid"
    size="small"
    class="custom-button"
    (click)="editButtonEvent.emit()"
  >
  {{'COMPONENTS.EDIT_PROFILE' | translate}}
  </ion-button>
</ion-item>

<ion-item lines="none" class="ion-hide-md-up">
  <ion-label>
    <h3 class="text-primary-dark" padding-bottom-half>
      <ion-icon color="primary" src="assets/svg/mail.svg" padding-right-half></ion-icon>
      {{ user?.userEmail }}
    </h3>
    <h3 class="text-primary-dark">
      <ion-icon color="primary" src="assets/svg/phone.svg" padding-right-half></ion-icon>
      {{ user?.userPhone | mask: 'tel' }}
    </h3>
  </ion-label>
</ion-item>
